import { Component, Input, ViewChild, OnInit, Output, EventEmitter, ChangeDetectorRef, forwardRef } from '@angular/core';
import { UiGroupControl } from '../../ui/controls/ui-group-control.model';
import { TextAreaControl } from '../../ui/controls/textarea-control.model';
import { TextControl } from '../../ui/controls/text-control.model';
import { ToggleControl } from '../../ui/controls/toggle-control.model';
import { DateControl } from '../../ui/controls/date-control.model';
import { BaseControl } from '../../ui/controls/base-control.model';
import { SearchGridComponent } from '../grid/search-grid.component';
import { ToolbarItem } from '../../interfaces/tool-bar-item.interface';
import { OnChangeArgs, SelectFieldComponent } from '../select-field/select-field.component';
import { faPlus, faRefresh, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ViewControl } from '../../ui/controls/view-control.model';
import { GridSettings } from '../../interfaces/grid-settings.interface';
import { BaseComponent } from '@core/models/base-component.model';
import { SelectControl } from '../../ui/controls/select-control.model';
import { LocalTimeConverterPipe } from '@shared/pipes/local-time-converter.pipe';
import { NumericControl } from '../../ui/controls/numeric-control.model';
import { Router } from '@angular/router';
import { INotificationService } from '../../services/inotification.service';
import { SearchPostDataService } from '../../services/search-post-data.service';
import { RemoteSearchService } from '../../../core/services/remote-search.service ';
import { SVGIcon, menuIcon } from '@progress/kendo-svg-icons';
import { WindowService } from '@progress/kendo-angular-dialog';
import { FormGroup, FormsModule } from '@angular/forms';
import { BooleanResult } from '@core/interfaces/boolean-result.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { BreadCrumbModule } from '@progress/kendo-angular-navigation';
import { ToolbarListComponent } from '../tool-bar/tool-bar.component';
import { ExpansionPanelModule, StackLayoutModule } from '@progress/kendo-angular-layout';
import { CheckBoxModule, NumericTextBoxModule, TextAreaModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { GridDataBindingDirective } from '../../directives/grid-data-binding.directive';

type EventType = 'search' | 'collapse';

@Component({
    selector: 'app-search',
    imports: [
        BreadCrumbModule,
        ToolbarListComponent,
        StackLayoutModule,
        ExpansionPanelModule,
        TextBoxModule,
        TextAreaModule,
        DatePickerModule,
        LabelModule,
        forwardRef(() => SelectFieldComponent),
        NumericTextBoxModule,
        FormsModule,
        SearchGridComponent,
        LocalTimeConverterPipe,
        ButtonModule,
        GridDataBindingDirective,
        SearchGridComponent,
        CheckBoxModule
    ],
    providers: [INotificationService, WindowService, SearchPostDataService, RemoteSearchService],
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.css']
})
export class SearchComponent extends BaseComponent implements OnInit {

  @ViewChild(SearchGridComponent) grid: SearchGridComponent;

  @Input() name: string = "";

  @Input() formName: string = "";

  /* Controller that will be called  */
  @Input() apiController: string;

  /* Various settings for setting up the grid */
  @Input() gridSettings: GridSettings<any>;

  /* List of views that will hold our controls/fields */
  @Input() views: ViewControl[];

  /* Property name to be used for Detail navigation (ID for most entities, Uniqnum for Item) */
  @Input() keyFieldName: string;

  /* Toolbar action items */
  @Input() toolbarItems: ToolbarItem[] = [];

  @Input() includeAddButton: boolean = true;

  @Input() showSearchContainer: boolean = true;

  @Input() showSearchToolButtons: boolean = true;
  /* Data */
  @Input() data: Array<any> = [];
  @Output() dataChange: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

  menuButtonTitle: string = "Hide";
  menu: SVGIcon = menuIcon;

  constructor(private router: Router,
    private notificationService: INotificationService,
    private postDataService: SearchPostDataService,
    private remote: RemoteSearchService
  ) { super(); }

  ngOnInit(): void {

    this.remote.loadData = false;

    this.bName = this.name;
    this.init();

    var toolbarSearch: ToolbarItem = {
      text: 'Search', //'general.search',
      icon: faSearch,
      hasMultiple: false,
      cssClass: 'primary-light',
      action: () => { this.search('search'); }
    };

    var toolbarReset: ToolbarItem = {
      text: 'Reset', /*'general.reset',*/
      icon: faRefresh,
      hasMultiple: false,
      action: () => { this.reset(); }
    };

    var toolbarAddNew: ToolbarItem = {
      text: 'general.add',
      icon: faPlus,
      hasMultiple: false,
      cssClass: 'success',
      action: () => { this.newDetailPage(); }
    };

    if (this.includeAddButton) {
      this.toolbarItems.unshift(toolbarAddNew);
    }

    if (this.showSearchToolButtons) {
      this.toolbarItems.unshift(toolbarReset);
      this.toolbarItems.unshift(toolbarSearch);
    }

    document.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.ctrlKey && e.key == 's') {
        this.search('search');
        e.preventDefault();
      }
    });

    this.menuButtonTitle = this.gridSettings.preloadData ? "Show" : "Hide";

    this.breadCrumbs = this.breadCrumbService.getBcs();

    if (this.showSearchContainer == false) {
      this.toggleSearchContainerVisibility();
    }
  }

  ngAfterViewInit(): void {
    if (this.gridSettings.preloadData) {
      this.search('search');
    }
  }

  toGroup(control: BaseControl): UiGroupControl {
    return control as UiGroupControl;
  }

  toTextArea(control: BaseControl) : TextAreaControl {
    return control as TextAreaControl;
  }

  toText(control: BaseControl) : TextControl {
    return control as TextControl;
  }

  toDate(control: BaseControl) : DateControl {
    return control as DateControl;
  }

  toToggle(control: BaseControl) : ToggleControl {
    return control as ToggleControl;
  }

  toNumeric(control: BaseControl): NumericControl {
    return control as NumericControl;
  }

  onSelectChange(control: BaseControl, args: OnChangeArgs): void {
    var select = control as SelectControl;
    if (select.onchange != undefined) {
      select.onchange(args);
    }
  }

  collapseSearchContainer(st: EventType) {

    let searchContainer = document.getElementsByClassName('searchContainer') as HTMLCollectionOf<HTMLElement>;

    let visible = searchContainer[0].style.flex === "" || searchContainer[0].style.flex === "0 0 20%";
    let hide: boolean = (st !== 'collapse') || (st === 'collapse' && visible);

    if (searchContainer.length != 0) {
      let searchParentClass = document.getElementsByClassName('searchParent') as HTMLCollectionOf<HTMLElement>;
      let searchParent = searchParentClass[0];

      // If user hits search with the search container already collapsed
      if (st == "search" && !visible) {
        return;
      }

    if (hide) {
      searchContainer[0].style.flex = "0 0 1%";

      searchParent.setAttribute('hide', '');
      setTimeout(() => { this.toggleSearchVisibility() }, 150);

      this.menuButtonTitle = "Show";

    } else {
      searchContainer[0].style.flex = "0 0 20%";

      searchParent.setAttribute('show', '');
      setTimeout(() => { this.toggleSearchVisibility() }, 300);

      this.menuButtonTitle = "Hide";
      }
    }
  }

  toggleSearchVisibility() {
    let searchParentClass = document.getElementsByClassName('searchParent') as HTMLCollectionOf<HTMLElement>;
    let searchParent = searchParentClass[0];

    let hiddenElm = document.getElementById('isSearchVisible') as HTMLInputElement;
    let isSearchVisible = hiddenElm.value;

    if (isSearchVisible === "false") {
      searchParent.removeAttribute('show');
      searchParent.style.display = "block";
      hiddenElm.value = "true";
    } else {
      searchParent.removeAttribute('hide');
      searchParent.style.display = "none";
      hiddenElm.value = "false";
    }
  }

  toggleSearchContainerVisibility() {
    let searchParentClass = document.getElementsByClassName('searchParent') as HTMLCollectionOf<HTMLElement>;
    let searchParent = searchParentClass[0];

    let searchContainerClass = document.getElementsByClassName('searchContainer') as HTMLCollectionOf<HTMLElement>;
    let searchContainer = searchContainerClass[0];

    searchParent.removeAttribute('hide');
    searchParent.style.display = "none";

    searchContainer.style.display = "none";
  }

  reset() {
    // set field values to original values
    var controls = this.flatten();
    for (var i = 0; i < controls.length; i++) {
      var control = controls[i];
      var originalValue = Reflect.get(control, "originalValue");
      var isSelect: boolean = control instanceof SelectControl;
      if (!isSelect) {
        Reflect.set(control, "value", null);
      } else {
        var select = control as SelectControl;
        if (select.allowMultiple) {
          Reflect.set(control, "value", null);
        } else {
          Reflect.set(control, "singleValue", null);
        }
      }
    }
  }

  newDetailPage() {
    var url: string = this.apiController + "/Detail/0";
    this.router.navigate([url]);
  }

  private flatten(): BaseControl[] {
    var arrs: BaseControl[][] = this.views.map(v => {

      const view: ViewControl = { ...v };
      var ctrls = view.controls;

      var rows = ctrls.map(g => (g as UiGroupControl).rows);
      var arrRows = rows.reduce((accumulator, value) => accumulator.concat(value), []);

      var controls = arrRows.map(r => r.controls);
      var arrControls = controls.reduce((accumulator, value) => accumulator.concat(value), []);

      return arrControls;
    });

    return arrs.reduce((accumulator, value) => accumulator.concat(value), []);
  }

  search(st: EventType) {
    this.collapseSearchContainer(st);

    // We can force a search page to require a value be entered (RequiredValidator). If we have field(s) with this validator and no value
    // show warning message that the field is required
    //var controls = this.flatten();
    //var requiredControls = controls.filter(x => x.isRequired && x.hasValue == false);
    //if (requiredControls.length > 0) {

    //  var translations = requiredControls.map(x => x.label);
    //  this.translate.get(translations).subscribe((obj: any) => {
    //    var labels = Object.keys(obj).map(key => obj[key]);
    //    var message = labels + " are required fields. Please enter a value.";
    //    this.notificationService.show({ type: "warning", title: "Required Fields", description: message });
    //    return;
    //  });

    //  // Stop the searching a throw up a warning message
    //  return;
    //}

    this.grid.showLoadingProgress();

    var postData: any = this.postDataService.buildPostData(this.views);

    this.remote.loadData = true;

    try {
      this.grid.db.bind(postData, this.apiController, this.grid, this.gridSettings.columns);
    } catch (err) {
      console.log(err);
    }
  }

  getIsRequired(control: BaseControl): string {
    if (control && control.isRequired) {
      return "*";
    }
    return "";
  }
}
